var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent-view-container"},[_c('notifications',{attrs:{"group":"app-notification"}}),(this.$store.getters.token)?[_c('HomeView')]:[_c('Login')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }